import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import dayjs from 'dayjs'
import {
  setShouldDisplayFreeTrialModal,
  shouldDisplayFreeTrialModal,
} from 'src/utils/sessionStorage'
import { IS_DEVELOPMENT } from 'src/utils/env'
import { useLoginUser } from 'src/api/user'
import { PAID_PLAN_CONTACT_URL } from 'src/utils/routes'
import { shouldDisplayModal } from 'src/components/hoc/asPage/modals'

const NOT_TARGET_PATH_FOR_MODAL = '/greet'
const PROMPT_PAID_PLAN_PERIOD = { start: 0, end: 14 }
export const REMAINING_PERIOD = { start: -6, end: -1 }

const getElapsedDaysForFreeTrial = (
  freeTrialEndAt: string | undefined | null,
): number | undefined => {
  if (freeTrialEndAt === undefined) return undefined

  const now = dayjs().startOf('day')
  const _freeTrialEndAt = dayjs(freeTrialEndAt).startOf('day')

  return now.diff(_freeTrialEndAt, 'day')
}

const withinRemainingPeriod = (elapsedDays: number) => {
  return (
    REMAINING_PERIOD.start <= elapsedDays && elapsedDays <= REMAINING_PERIOD.end
  )
}

const withinPromptPeriod = (elapsedDays: number) => {
  return (
    PROMPT_PAID_PLAN_PERIOD.start <= elapsedDays &&
    elapsedDays <= PROMPT_PAID_PLAN_PERIOD.end
  )
}

export const useFreeTrial = () => {
  const router = useRouter()
  const [elapsedDays, setElapsedDays] = useState<number>()
  const [isFreeTrialModalOpen, setIsFreeTrialModalOpen] = useState(false)
  const { user } = useLoginUser({
    dedupingInterval: IS_DEVELOPMENT ? undefined : 300000,
  })

  useEffect(() => {
    if (!user) return
    if (!shouldDisplayModal(router.pathname)) return
    if (router.pathname.includes(NOT_TARGET_PATH_FOR_MODAL)) return

    const _elapsedDays = getElapsedDaysForFreeTrial(user.plan.freeTrialEndAt)
    setElapsedDays(_elapsedDays)

    if (_elapsedDays == null || !shouldDisplayFreeTrialModal()) return
    if (
      withinRemainingPeriod(_elapsedDays) ||
      (withinPromptPeriod(_elapsedDays) && user.plan.free)
    )
      setIsFreeTrialModalOpen(true)
  }, [elapsedDays, user])

  const closeFreeTrialModal = () => {
    setShouldDisplayFreeTrialModal(false)
    setIsFreeTrialModalOpen(false)
  }

  const register = () => {
    setShouldDisplayFreeTrialModal(false)
    setIsFreeTrialModalOpen(false)

    window.open(PAID_PLAN_CONTACT_URL)
  }

  return {
    isFreeTrialModalOpen,
    elapsedDays,
    register,
    closeFreeTrialModal,
  }
}
